// src/mocks/data/user.demo.js
// Demo user injected into localStorage before React mounts.
// AuthProvider reads this on init → user is pre-authenticated.
//
// Role: ClientAdministrator — required for full route access ('*').
// All organization data is completely fictional.

export const DEMO_TOKEN = 'demo-access-token-horizontepyme';
export const DEMO_REFRESH_TOKEN = 'demo-refresh-token-horizontepyme';

export const DEMO_USER = {
    // Required fields validated by AuthProvider.loadAuthStateFromLocalStorage
    userId: 9999,
    organizationId: 9999,
    role: 'ClientAdministrator',
    clientDatabaseName: 'demo_ferreteria',

    // Profile — fully fictional
    username: 'demo',
    firstName: 'Demo',
    lastName: 'Ferretería',
    email: 'demo@demo.horizontepyme.com',

    // Feature flags — enable all to showcase full app
    signageEnabled: true,
    afipEnabled: true,
    a4InvoiceEnabled: true,
    totemEnabled: false,
};
